import { useEffect, useRef, useCallback } from 'react';
export function useTriggerHandlers({ onSingle, onDouble, delay = 250, }) {
    const timerRef = useRef(null);
    const skipNextClickRef = useRef(false);
    useEffect(() => {
        return () => {
            if (timerRef.current)
                clearTimeout(timerRef.current);
        };
    }, []);
    const handleClick = useCallback((event) => {
        if (skipNextClickRef.current) {
            skipNextClickRef.current = false;
            return;
        }
        if (timerRef.current)
            clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            onSingle({ type: 'click', event });
            timerRef.current = null;
        }, delay);
    }, [onSingle, delay]);
    const handleDoubleClick = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        onDouble?.();
    }, [onDouble]);
    const handleKeyDown = useCallback((event) => {
        if (event.key !== 'Enter')
            return;
        event.preventDefault();
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        skipNextClickRef.current = true;
        onSingle({ type: 'key', key: event.key, event });
    }, [onSingle]);
    return { handleClick, handleDoubleClick, handleKeyDown };
}
